import { showToast } from '@design-system';
import { Favorite, useAddFavoriteMutation, useDeleteFavoriteMutation, useGetFavoritesMutation } from '@services';
import { useEffect, useState } from 'react';

export const useFavorites = () => {
    const [favorites, setFavorites] = useState<Array<Favorite>>([]);

    const [getFavorites, { isLoading: isLoadingFavorites, data: favoritesData }] = useGetFavoritesMutation();
    const [addFavorite, { isLoading: isLoadingAddFavorite, isSuccess: isSuccessAddFavorite }] = useAddFavoriteMutation();
    const [deleteFavorite, { isLoading: isLoadingDeleteFavorite, isSuccess: isSuccessDeleteFavorite }] = useDeleteFavoriteMutation();

    const fetchFavorites = () => {
        getFavorites();
    };

    const handleAddFavorite = (reference: string) => {
        addFavorite(reference);
    };

    const handleDeleteFavorite = (id: number) => {
        deleteFavorite(id);
    };

    useEffect(() => {
        fetchFavorites();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isLoadingAddFavorite) {
            return;
        }
        if (isSuccessAddFavorite) {
            fetchFavorites();
            showToast({
                type: 'success',
                message: 'Page ajoutée à vos favoris !'
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingAddFavorite, isSuccessAddFavorite]);

    useEffect(() => {
        if (isLoadingDeleteFavorite) {
            return;
        }
        if (isSuccessDeleteFavorite) {
            showToast({
                type: 'neutral',
                message: 'Page retirée de vos favoris.'
            });
            fetchFavorites();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingDeleteFavorite, isSuccessDeleteFavorite]);

    useEffect(() => {
        if (isLoadingFavorites) {
            return;
        }
        if (favoritesData) {
            setFavorites(favoritesData);
        }
    }, [isLoadingFavorites, favoritesData]);

    return { isLoadingFavorites, favorites, handleAddFavorite, handleDeleteFavorite };
};
